enum RoleId {
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
  GUEST = "GUEST",
}

export default RoleId;
